import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const ProductionPage = lazy(() => import('@/pages/production'));

export const Route = createFileRoute('/production')({
  component: function ProductionRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <ProductionPage />
      </Suspense>
    );
  },
});
